/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import data from '../../data/rating'
import { ImageCover } from 'components/cover'
import { Introduction } from 'components/introduction'
import posterImage from 'images/cover-landscape.jpg?sizes[]=640w&sizes[]=1280w&sizes[]=1800w&sizes[]=2360w&placeholder'
import portraitPosterImage from 'images/cover-portrait.jpg?sizes[]=640w&sizes[]=1280w&sizes[]=1800w&sizes[]=2360w&placeholder'
import { Ranking } from 'components/ranking'

// TODO Set the correct article ID here
const ARTICLE_ID = '23048823'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} inverted mediaName='sonntagszeitung' />
      <ThemeSwitch />

      <ImageCover
        inverted
        poster={posterImage}
        title='Die besten Winterhotels'
        subtitle='Das grosse Rating 2019: Alle Aufsteiger, Absteiger und Neueinsteiger.'
        coverHeight='calc(100vh - 4ex)'
        position='top'
        padding='calc(40px + 18%)'
        mobilePadding='calc(40px + 10%)'
        verticalPosition='left'
        verticalPadding='40%'
        showTextShadow={false}
        showTopGradient
        portraitPoster={portraitPosterImage}
        caption="Für Halbgötter: Badrutt's Palace, St. Moritz."
      />

      <Introduction />

      <Ranking rankingTable={data.data} />

      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        credits={[
          ['Hotelranking und Texte', 'Karl Wild'],
          ['Digitale Umsetzung', 'Kaspar Manz, Interaktiv-Team']
        ]}
        mediaName='sonntagszeitung'
        hidePortfolioTeaser
        hideUserFeedback
        topHalfClassName='grey'
      />
    </div>
  )
}
